<template>
  <div class="sms-verification">
    <button class="sms-back" type="button" title="返回账号密码登录" @click="$emit('back')">
      <i class="el-icon-arrow-left"></i>
    </button>
    <div class="sms-title">验证身份</div>
    <p class="sms-subtitle">当前设备需要手机验证，验证通过后将直接登录。</p>
    <div class="sms-method"><span>手机号</span></div>
    <el-input
      class="sms-code-input"
      :value="value"
      maxlength="6"
      placeholder="请输入验证码"
      @input="$emit('input', $event)"
      @keyup.enter.native="$emit('verify')"
    >
      <el-button
        slot="append"
        :loading="codeSending"
        :disabled="codeCountdown > 0"
        @click="$emit('get-code')"
      >{{ codeButtonText }}</el-button>
    </el-input>
    <div class="sms-phone"><span>手机号</span>{{ maskedPhone }}</div>
    <el-button class="sms-submit" type="primary" :loading="smsVerifying" @click="$emit('verify')">
      立即验证
    </el-button>
  </div>
</template>

<script>
export default {
  name: "InlineSmsVerification",
  props: {
    value: { type: String, default: "" },
    phone: { type: String, default: "" },
    codeButtonText: { type: String, default: "获取验证码" },
    codeSending: { type: Boolean, default: false },
    codeCountdown: { type: Number, default: 0 },
    smsVerifying: { type: Boolean, default: false }
  },
  computed: {
    maskedPhone() {
      var phone = String(this.phone || "");
      if (phone.length < 7) return phone;
      return phone.slice(0, 3) + "******" + phone.slice(-2);
    }
  }
};
</script>

<style lang="scss" scoped>
.sms-verification {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  color: #1f2329;
  text-align: left;

  .sms-back {
    display: inline-block;
    margin-bottom: 16px;
    padding: 0;
    border: none;
    background: transparent;
    color: #333333;
    font-size: 22px;
    cursor: pointer;
    transition: color 0.2s;

    &:hover { color: #4fc2ba; }
  }

  .sms-title {
    margin: 0 0 8px;
    color: #1a1a1a;
    font-size: 24px;
    line-height: 1.3;
    font-weight: 700;
  }

  .sms-subtitle {
    margin: 0 0 20px;
    color: #888888;
    font-size: 13px;
    line-height: 1.6;
  }

  .sms-method {
    display: flex;
    margin-bottom: 18px;

    span {
      position: relative;
      padding-bottom: 8px;
      color: #1a1a1a;
      font-size: 15px;
      font-weight: 600;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        border-radius: 1px;
        background: #1a1a1a;
      }
    }
  }

  ::v-deep .sms-code-input {
    margin: 0;

    .el-input__inner {
      height: 50px;
      padding: 0 20px;
      border-color: #d8dce6;
      border-radius: 25px 0 0 25px;
      font-size: 15px;
    }

    .el-input-group__append {
      padding: 0 18px;
      border-color: #d8dce6;
      border-radius: 0 25px 25px 0;
      background: #ffffff;

      .el-button {
        width: auto;
        height: 48px;
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 500;

        &:hover { color: #4fc2ba; }

        &.is-disabled,
        &:disabled {
          color: #c0c4cc;
        }
      }
    }
  }

  .sms-phone {
    margin: 16px 0 20px;
    padding-left: 4px;
    color: #666666;
    text-align: left;
    font-size: 14px;

    span {
      margin-right: 8px;
    }
  }

  .sms-submit {
    width: 100%;
    height: 48px;
    margin: 0 0 20px;
    border: none;
    border-radius: 24px;
    background: #4fc2ba;
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;

    &:hover,
    &:focus {
      background: #3aada5;
    }
  }
}

@media (max-width: 768px) {
  .sms-verification {
    .sms-title { font-size: 24px; }
    .sms-subtitle { margin-bottom: 24px; }
  }
}
</style>